import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M79.969 56.54c5.246-1.706 9.038-6.636 9.038-12.451C89.007 36.86 83.147 31 75.918 31S62.83 36.86 62.83 44.089c0 5.86 3.852 10.821 9.162 12.49-6.996 1.356-12.801 6.048-15.696 12.354-.318.693.23 1.481.992 1.477l37.675-.197c.811-.004 1.304-.868.93-1.587-3.12-6.002-9.05-10.772-15.923-12.087"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M43.766 56.54c5.246-1.706 9.038-6.636 9.038-12.451C52.804 36.86 46.944 31 39.715 31s-13.089 5.86-13.089 13.089c0 5.86 3.852 10.821 9.162 12.49-6.996 1.356-12.801 6.048-15.696 12.354-.318.693.23 1.481.992 1.477l37.675-.197c.811-.004 1.304-.868.93-1.587-3.12-6.002-9.05-10.772-15.923-12.087"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M61.446 68.511c6.105-1.855 10.548-7.529 10.548-14.24 0-8.219-6.662-14.881-14.88-14.881-8.22 0-14.882 6.662-14.882 14.88 0 6.765 4.513 12.475 10.693 14.284-8.077 1.472-14.792 6.847-18.12 14.099-.363.788.26 1.683 1.126 1.679l42.834-.224c.922-.005 1.483-.986 1.057-1.805C76.234 75.4 69.376 69.93 61.446 68.51M79.606 6.799a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M97.419 20.943a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M9.066 71.854a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M27.722 84.418a1.5 1.5 0 0 0-2.122-2.121l-3.936 3.936-3.936-3.936a1.5 1.5 0 0 0-2.122 2.121l3.937 3.936-3.937 3.937a1.5 1.5 0 1 0 2.122 2.121l3.936-3.936 3.936 3.936a1.5 1.5 0 0 0 2.122-2.121l-3.937-3.937zM107.066 40.227a1.5 1.5 0 0 0-3 0v5.567H98.5a1.5 1.5 0 1 0 0 3h5.566v5.567a1.5 1.5 0 1 0 3 0v-5.567h5.567a1.5 1.5 0 0 0 0-3h-5.567z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconPeopleBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPeopleBrand);
export default Memo;
